import _ from "lodash";
import i18n from "i18next";
import moment from "moment";

import { formatQuantityValue } from "../helpers/unitOfMeasurementHelpers";

export const dateDisplayFormats = [
  { value: "YYYY-MM-DD", label: "2012-03-14" },
  { value: "YYYY MMM DD", label: "2012 Mar 14" },
  { value: "DD-MM-YYYY", label: "14-03-2012" },
  { value: "DD MMM YYYY", label: "14 Mar 2012" },
  { value: "MM-DD-YYYY", label: "03-14-2012" },
  { value: "MMM DD YYYY", label: "Mar 14 2012" }
];

export const formatNotificationDate = (date, datePreference, emptyValue = "-") => {
  if (!date) return emptyValue;

  const dateToConvert = moment(date);
  const formatPreference = _.toUpper(datePreference || "YYYY-MM-DD");

  return dateToConvert.format(formatPreference);
};

export const formatDate = (dateString, datePreference, emptyValue = "-") => {
  if (!dateString) return emptyValue;

  const dateToConvert = moment(dateString, "YYYY-MM-DD HH:mm:ss");
  const hasTime = dateToConvert.format("HH:mm:ss") !== "00:00:00";
  const formatPreference = _.toUpper(datePreference || "YYYY-MM-DD");

  return dateToConvert.format(`${formatPreference}${hasTime ? " HH:mm" : ""}`);
};

export const formatPlannedDate = (quantityPlanned, load, userMetadata) => {
  const { dateDisplayFormat } = userMetadata;

  if (load.plannedDate) {
    const formattedDate = formatDate(load.plannedDate, dateDisplayFormat);
    return `${formatQuantityValue(quantityPlanned)} ${i18n.t("loads.on")} ${formattedDate}`;
  }

  return formatQuantityValue(quantityPlanned);
};



// WEBPACK FOOTER //
// ./src/helpers/dateHelpers.js